export enum ROLES_STATUS {
  SUPER_ADMIN = 1,
  COMPANY_ADMIN = 2,
  DRIVER = 3,
  DISPATCHER = 4,
  ACCOUNTANT = 5,
  CLIENT = 6,
  AGENT = 7,
}
